import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-gray-200 py-4 px-6 mt-8" data-id="element-68">
      <div className="flex justify-between items-center" data-id="element-69">
        <p className="text-xs text-gray-500" data-id="element-70">
          Alle priser ekskl. moms. Kun visning – ingen redigering.
        </p>
        <p className="text-xs text-gray-400" data-id="element-71">Seneste synk: 17-04-2025 14:35</p>
      </div>
    </footer>;
}